/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import ln from '@stdlib/math/base/special/ln';


// MAIN //

/**
* Returns the differential entropy of a uniform distribution.
*
* @param {number} a - minimum support
* @param {number} b - maximum support
* @returns {number} differential entropy
*
* @example
* var v = entropy( 0.0, 1.0 );
* // returns 0.0
*
* @example
* var v = entropy( 4.0, 12.0 );
* // returns ~2.079
*
* @example
* var v = entropy( -4.0, 4.0 );
* // returns ~2.079
*
* @example
* var v = entropy( 1.0, -0.1 );
* // returns NaN
*
* @example
* var v = entropy( 2.0, NaN );
* // returns NaN
*
* @example
* var v = entropy( NaN, 2.0 );
* // returns NaN
*/
function entropy( a, b ) {
	if (
		a >= b
	) {
		return NaN;
	}
	return ln( b-a );
}


// EXPORTS //

export default entropy;
